






































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import TheTableDeliveryOrders from '@/components/orders/TheTableDeliveryOrders.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing function
import {getDeliveryOrders} from '@/ts/deliveries/get-delivery-orders';
// import {getRestaurantOrders} from '@/ts/orders/get-orders';
import Pusher from 'pusher-js';
// import {getAddressLocation} from '@/ts/delivery/get-address-location';
// import {loaded} from 'vue2-google-maps';
// import {getDeliveryOrders} from '@/ts/delivery/get-delivery-orders';

export default {
    name: 'PageDeliveryOrders',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableDeliveryOrders,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: [],
            status: {},
            search_param: '',
            channel: {},
            lat: 0,
            lan: 0,
        };
    },
    methods: {
        setPosition(position) {
            this.lat = position.coords.latitude;
            this.lan = position.coords.longitude;

            this.$gmapApiPromiseLazy().then((google) => {
                const directionsService = new google.maps.DirectionsService();
                const directionsDisplay = new google.maps.DirectionsRenderer();

                directionsDisplay.setMap(this.$refs.map.$mapObject);
                directionsService.route({
                    origin:  new google.maps.LatLng(this.lat, this.lan),
                    destination: this.$store.getters.response[0].attributes.town + ', '
                        + this.$store.getters.response[0].attributes.address,
                    travelMode: 'WALKING',
                }, (response, status) => {
                    if (status === 'OK') {
                        directionsDisplay.setDirections(response);
                    } else {
                        window.alert('Directions request failed due to ' + status);
                    }
                });
            });

        },
        error() {
            this.$swal.fire({
                title: 'Възникна грешка!',
                type: 'error',
                text: 'Постоположението не може да бъде открито!',
            });
        },
    },
    beforeDestroy() {
        this.channel.unbind();
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants'},
        }, {
            text: 'Поръчки',
            to: { name: 'orders-delivery', params: { id: localStorage.getItem('slug') } },
        }, {
            text: 'Изпълнение на доставка',
        }];

        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
    },
    mounted() {
        getDeliveryOrders().then(() => {
            this.$store.dispatch('setResponse', this.$store.getters.response.filter((item) => {
                return item.id === this.$route.params.order_id;
            }));
            this.$gmapApiPromiseLazy().then(() => {
                // get the location via Geolocation API
                if ('geolocation' in navigator) {
                    const pusher = new Pusher('1627464172e6c947c3f4', {
                        cluster: 'eu',
                        encrypted: true,
                        authEndpoint: 'https://api.foodninja.net/broadcasting/auth',
                        auth: {
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('jwt'),
                            },
                        },
                    });

                    // Subscribe to the channel we specified in a Laravel Event
                    this.channel = pusher.subscribe('private-deliveries.' + localStorage.getItem('id'));
                    this.channel.bind('pusher:subscription_succeeded', () => {
                        // safe to now trigger events
                        // use the watchPosition API to watch the changing location
                        // and trigger events with new coordinates
                        const options = {
                            enableHighAccuracy: true,
                            maximumAge        : 30000,
                        };
                        navigator.geolocation.watchPosition(this.setPosition, this.error, options);

                        // also start a setInterval to keep sending the location every 5 secs
                        setInterval(() => {
                            // not using `triggerLocationChangeEvents` to keep the pipes different
                            this.channel.trigger('client-location', { lat: this.lat, lng: this.lan });
                        }, 5000);
                    });
                }
            });
        });
    },
};
